import { useContext, useEffect, useState } from 'react';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { AddNewItemsAction } from '../../../lib/context/SmartSendContextModels';
import { CreateItemReq, CreateItemRes } from '../../../lib/helpers/useItemCreateHelper';
import { CsvPanel } from '../panels/CsvPanel';
import { GenericEditProps } from './Edit';
import RenderCreateItemMessage from './RenderCreateItemMessage';
import { EventSections } from '../../../lib/events/EventLogger';
import { Tagged } from '../../Tagged';
import useCreateItemsHelper from '../../../lib/helpers/useItemCreateHelper';
import { P2GSidePanel } from '~/components/sidepanel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { useAnalytics } from '@parcel2go/npm-p2g-app';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

export default function Csv(props: GenericEditProps) {
  const { createItemsHelper } = useCreateItemsHelper();
  const ctx = useContext(SmartSendContext);
  const [createMessages, setCreateMessages] = useState<string[]>([]);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const { track } = useAnalytics();

  useEffect(() => {
    track({
      type: 'csv_upload_loaded',
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, EventSections.CsvUpload])
      }
    });
  }, []);

  async function saveNewItems(items: CreateItemReq[]): Promise<CreateItemRes[]> {
    const summary = await createItemsHelper(
      items,
      (ii) => {
        ctx.dispatch(new AddNewItemsAction(ii));
      },
      () => {},
      () => {}
    );

    if (summary.failed.length === 0) {
      if (summary.messages.length > 0) {
        setCreateMessages(summary.messages);
      } else {
        props.onClose();
      }
    }

    return summary.failed;
  }

  return (
    <P2GSidePanel
      open={true}
      onClose={props.onClose}
      anchor="right"
      title={t('CSV_UPLOAD_SIDEPANEL_TITLE', { defaultValue: 'CSV Upload' })}
    >
      <Tagged tag="panel-csv">
        {createMessages.length > 0 ? (
          <RenderCreateItemMessage messages={createMessages} onClose={props.onClose} />
        ) : (
          <CsvPanel close={props.onClose} onSave={saveNewItems} />
        )}
      </Tagged>
    </P2GSidePanel>
  );
}
